import { v4 as uuidv4 } from 'uuid';

import { ModuleSlotMap } from '~/modules';
import { ModuleSlotId, ModuleType } from '~/modules/Module.types';

export const modulesConfig: ModuleSlotMap = {
  [ModuleSlotId.MAIN]: [
    {
      id: uuidv4(),
      moduleType: ModuleType.RISK_SUPPLIER_LIST_WIDGET,
      grid: { size: { xs: 12, md: 6, xl: 6 } },
    },
  ],
};
